import { Component, Input } from '@angular/core';
import { IPatient, IDevice } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../../../shared/abstracts/details/abstract-details/abstract-details.component';
import { Router } from '@angular/router';

@Component({
  selector: 'inc-patient-base',
  templateUrl: './patient-base.component.html',
  styleUrls: ['./patient-base.component.scss'],
})
export class PatientBaseComponent extends AbstractDetailsComponent<IPatient> {
  @Input() expanded = false;
  @Input() showMore = false;
  @Input() devices?: IDevice[] = [];

  constructor(private router: Router) {
    super();
  }

  navTo(url: string, type: string, object: any, event?: any) {
    if (event) { event.stopPropagation(); }
    if (type === 'device') { localStorage.removeItem('device'); }
    this.router.navigateByUrl(url, { state: { parameter: object } });
  }
}
